import moment from "moment";
import commonFn from "@/commons/commonFunction";
import { MSEnum } from "@/commons/enumeration";

export default {
  resetState(state) {
    let x = 1;
    //Object.assign(state, defaultConfigState);
  },
  updateConfig: function (state, payload) {
    let currentDate = moment(payload.CurrentDate).toDate();
    state.ConfigInfo = {
      ...state.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  updateOrganizationUnit: function (state, payload) {
    let org = {},
      fields = ["OrganizationUnitID", "OrganizationUnitName", "MISACodeID"];
    fields.forEach((i) => {
      org[i] = payload[i];
    });

    //org
    state.OrganizationUnit = org;
    commonFn.setLocalStorage("OrganizationUnit", JSON.stringify(org));

    //update context
    state.Context.OrganizationUnitID = payload.OrganizationUnitID;
    state.Context.MISACodeID = payload.MISACodeID;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateCulture: function (state, payload) {
    state.Context.Culture = payload;
  },

  updateAccessTokenToState(state, accessToken) {
    state.Token = accessToken;
    state.User = commonFn.parseJwt(accessToken);
    let tmpUserLocal = { ...state.User };
    delete tmpUserLocal.aud;
    delete tmpUserLocal.auth_time;
    delete tmpUserLocal.client_id;
    delete tmpUserLocal.iat;
    delete tmpUserLocal.idp;
    delete tmpUserLocal.iss;
    delete tmpUserLocal.scope;
    //commonFn.setLocalStorage("User", JSON.stringify(tmpUserLocal));
  },

  updateToken(state, payload) {
    state.TokenTimeout = new Date(Date.now() + payload.expiresIn * 1000).getTime();
    state.Token = payload.accessToken;
    state.refreshToken = payload.refreshToken;
    state.User = commonFn.parseJwt(payload.accessToken);
    // let context = {};
    // for (let i in payload.context) {
    //   let value = payload.context[i];
    //   if (value != null && typeof value !== 'undefined') {
    //     context[i] = value;
    //   }
    // }
    // state.Context = context;
    // state.GettingStarted = payload.getting;
    // //NMSINH: xử lý phân quyền
    // let permission = {};
    // if (Array.isArray(payload.permission) && payload.permission.length > 0) {
    //   payload.permission.forEach(item => {
    //     let role = JSON.parse(item);
    //     if (Array.isArray(role)) {
    //       role.forEach(r => {
    //         if (Array.isArray(r.Childrens)) {
    //           r.Childrens.forEach(c => {
    //             let code = c.SubSystemCode;
    //             if (!permission.hasOwnProperty(code)) {
    //               permission[code] = [];
    //             }
    //             if (Array.isArray(c.Permissions)) {
    //               c.Permissions.forEach(p => {
    //                 if (permission[code].indexOf(p) === -1) {
    //                   permission[code].push(p);
    //                 }
    //               });
    //             }
    //           });
    //         }
    //       });
    //     }
    //   });
    // }
    // state.Permission = permission;
    // state.OrganizationUnit = payload.org;
    // // License
    // state.License = payload.license;
    // //ghi context vào localstorage
    // commonFn.setLocalStorage("Permission", JSON.stringify(state.Permission));
    commonFn.setLocalStorage("TokenTimeout", state.TokenTimeout);
    // commonFn.setLocalStorage("Token", state.Token);
    // commonFn.setLocalStorage("refreshToken", state.refreshToken);
    let tmpUserLocal = { ...state.User };
    delete tmpUserLocal.aud;
    delete tmpUserLocal.auth_time;
    delete tmpUserLocal.client_id;
    delete tmpUserLocal.iat;
    delete tmpUserLocal.idp;
    delete tmpUserLocal.iss;
    delete tmpUserLocal.scope;
    //commonFn.setLocalStorage("User", JSON.stringify(tmpUserLocal));
    // commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
    // commonFn.setLocalStorage("OrganizationUnit", JSON.stringify(state.OrganizationUnit));
    // commonFn.setLocalStorage("License", JSON.stringify(state.License));
    // commonFn.setLocalStorage("LicenseError", payload.licenseError);
    // if (state.GettingStarted) {
    //   commonFn.setLocalStorage("GettingStarted", JSON.stringify(state.GettingStarted));
    // }
  },
  updateContext(state, payload) {
    state.Context = payload;
    commonFn.setLocalStorage("Context", JSON.stringify(state.Context));
  },
  updateLoading(state, payload) {
    state.Loading = payload;
  },
  updatePermission(state, payload) {
    state.Permission = payload;
  },
  /**
   * clear thông tin phiên đăng nhập
   */
  removeToken(state) {
    state.Token = null;
    state.Context = null;
    state.User = null;
    state.Permission = null;

    //ghi context vào localstorage
    commonFn.removeLocalStorage("Permission");
    commonFn.removeLocalStorage("TokenTimeout");
    commonFn.removeLocalStorage("Token");
    commonFn.removeLocalStorage("Context");
    commonFn.removeLocalStorage("User");
    commonFn.removeLocalStorage("GettingStarted");
    commonFn.removeLocalStorage("OrganizationUnit");
    commonFn.removeLocalStorage("License");
    commonFn.removeLocalStorage("LicenseError");
  },
  updateLeftMenuCollapse(state, payload) {
    state.LeftMenuCollapse = payload;
  },
  completeGetting(state) {
    let getting = {
      GettingStarted: true,
      SeenGetting: true,
    };
    state.GettingStarted = getting;
    commonFn.setLocalStorage("GettingStarted", JSON.stringify(getting));
    window._getting = getting;
  },
};
